import { render, staticRenderFns } from "./pointRankList.vue?vue&type=template&id=ce6616ca&scoped=true"
import script from "./pointRankList.vue?vue&type=script&lang=js"
export * from "./pointRankList.vue?vue&type=script&lang=js"
import style0 from "./pointRankList.vue?vue&type=style&index=0&id=ce6616ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6616ca",
  null
  
)

export default component.exports